import externalServices from './externalServices.json';

export const EXTERNAL_SERVICES_CONFIG = {
  PAYMENT_HOST: externalServices.baseUrls.payment,
  API_HOST: externalServices.baseUrls.api,
  DATA_STORE_HOST: externalServices.baseUrls.dataStore,
  DEFAULT_GROUP: externalServices.defaultGroup,
};

export default EXTERNAL_SERVICES_CONFIG;
